import {Directive, Host, HostListener, Input, OnInit, SkipSelf} from '@angular/core';
import {AbstractControl, ControlContainer} from '@angular/forms';

@Directive({
    selector: '[utilsCheckValidity]'
})
export class CheckValidityDirective implements OnInit {

    @Input()
    public utilsCheckValidity: string;
    @Input()
    public formControlName: string;
    @Input()
    public checkAdditionalControls: Array<string>;
    private control: AbstractControl;

    constructor(@Host() @SkipSelf() protected readonly controlContainer: ControlContainer) {
    }

    @HostListener('blur')
    public onBlur(): void {

        if (!this.control) {
            return;
        }

        this.control.markAsTouched();
        setTimeout(() => this.control.updateValueAndValidity(), this.formControlName === 'date' ? 250 : 0);

        this.checkConditionalControls();
    }

    public ngOnInit(): void {
        if (!this.controlContainer) {
            return;
        }

        let controlName = this.formControlName;
        if (this.utilsCheckValidity) {
            controlName = this.utilsCheckValidity;
        }

        this.control = this.controlContainer.control.get(controlName);
    }

    private checkConditionalControls(): void {

        if (!Array.isArray(this.checkAdditionalControls)) {
            return;
        }

        this.checkAdditionalControls.forEach((controlName: string) => {
            const additionalControl: AbstractControl = this.controlContainer.control.get(controlName);
            if (additionalControl) {
                additionalControl.updateValueAndValidity();
            }
        });
    }
}
